// extracted by mini-css-extract-plugin
module.exports = {"block":"RegWallBarrier_block__pcwQz","joinBtn":"RegWallBarrier_joinBtn__3VTpD","loginBtn":"RegWallBarrier_loginBtn__bOpgR","container":"RegWallBarrier_container__6msGK"};